//Generated File 
export const AllReports = `AllReports`;
export const AutoDashBoards = `AutoDashBoards`;
export const Dashboard = `Dashboard`;
export const DashboardsGroup = `DashboardsGroup`;
export const EntityList = `EntityList`;
export const InternalLink = `InternalLink`;
export const Link = `Link`;
export const NewRecord = `NewRecord`;
export const Record = `Record`;
export const Report = `Report`;
export const ReportsGroup = `ReportsGroup`;
export const UserFavourites = `UserFavourites`;
